import React, { useState, useEffect, useSelector } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import { GrDocumentVerified } from "react-icons/gr";
import { BsPencilSquare } from "react-icons/bs";
import { optionsBranch } from "../data/branch-data";
import { generateStatus } from "../utils/generateDisplay";
import {
  getInternshipRequestById,
  getLogbookById,
  getInternReportById,
  getProposalById,
  getDocumentReqStudent,
  updateRatingLogbook,
  getInternManualById,
  updateRatingInternManual,
  getCoopReportById,
  updateRatingProposal,
  getTotalScoreOnly
} from "../api/crud";
import { getAssessment_companycoop, getAssessment_reportcoop, getAssessmentCoop, getAssessment_presentcoop, getAssessment, getAssessment_report } from "../api/crud";
import { Box, Button, Stack, Divider, IconButton, Tooltip, Container } from "@mui/material";
import ModalView from "./ModalView";
import InternPageReview from "./InternPageReview";
import DrawerView from "./DrawerView";
import FormReview from "./FormReview";
import FormReviewCompleted from "./FormReviewCompleted";
import { List } from "@material-ui/core";
import AssignmentIcon from "@mui/icons-material/Assignment";
import MailIcon from "@mui/icons-material/Mail";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { convertDateToString, matchOptions } from "../utils/function";
import { internType } from "../data/interntype-data";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Rating from "@mui/material/Rating";
import { CheckCircle, Edit, Email, OpenInNew } from "@mui/icons-material";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { Document, Page } from "@react-pdf/renderer";
import { updateSnackbar } from "../redux/action/dataAction";
import { useDispatch } from "react-redux";
import { engApi } from "../api/engApi";
//check screen size mobile or desktop
import useMediaQuery from "@mui/material/useMediaQuery";
import { set } from "lodash";
import Skeleton from "@mui/material/Skeleton";
import { currentYear } from "src/data/config";
import { convertDateThai } from "src/utils/function";
import TaskIcon from '@mui/icons-material/Task';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';




//import { Document, Page } from 'react-pdf';
const labels = {
  0:'ไม่ได้ส่ง',
  //0.5: 'Useless',
  1: 'น้อยมาก',
  //1.5: 'Poor',
  2: 'น้อย',
  //2.5: 'Ok',
  3: 'ปานกลาง',
  //3.5: 'Good',
  4: 'ดี',
 // 4.5: 'Excellent',
  5: 'ดีมาก',
};

function getLabelText(value) {
  return `${value} Star${value !== 1 ? 's' : ''}, ${labels[value]}`;
}

const InternStdDetail = ({ internRequestId, onRefreshData }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:767px)');

  //const profile = useSelector((state) => state.profileReducer.profile);
  const [isLoading, setIsLoading] = useState(false);
  const [profileDetail, setProfileDetail] = useState(null);
  const [logbookDetail, setLogbookDetail] = useState(null);
  const [InternReportDetail, setInternReportDetail] = useState(null);
  const [CoopReportDetail, setCoopReportDetail] = useState(null);
  const [internManualDetail, setInternManualDetail] = useState(null);
  const [proposalDetail, setProposalDetail] = useState(null);
  const [isOpenModalForm, setIsOpenModalForm] = useState(false);
  const [isOpenDrawerFormReview, setIsOpenDrawerFormReview] = useState(false);
  const [userInternData, setuserInternData] = useState(null);
  const [onEdit, setOnEdit] = useState(false);
  const [Copied, setCopied] = useState(false);
  const [CopiedMail, setCopiedmail] = useState(false);
  const [ratings, setRatings] = useState({}); // initialize state with an empty object
  const dispatch = useDispatch();
  const [hover, setHover] = React.useState(-1);
  const [auditor, setAuditor] = useState(null);
  // loading state for async rating save (keyed by req_id or item id)
  const [ratingLoading, setRatingLoading] = useState({});



  const getUsername = localStorage.getItem("name");
  var docReq;

  const handleRatingChange = (id, newValue) => {
    setRatings(prevRatings => ({ ...prevRatings, [id]: newValue })); // update state with new rating value

    // make a request to your backend to update the database
    // replace with your actual API call
    updateRatingLogbook(id, newValue, getUsername?.split(" ")[0])
      .then(() => {
        if (onRefreshData) {
          setTimeout(() => {
            onRefreshData();
          }, 500);
        }
      });
   
  };

  
  const handleRatingChange2 = (id, newValue) => {
    setRatings(prevRatings => ({ ...prevRatings, [id]: newValue })); // update state with new rating value

    // make a request to your backend to update the database
    // replace with your actual API call
    updateRatingInternManual(id, newValue, getUsername?.split(" ")[0])
      .then(() => {
        if (onRefreshData) {
          setTimeout(() => {
            onRefreshData();
          }, 500);
        }
      });
    
   
  };

  const handleRatingChange3 = (id, req_id, newValue) => {
    setRatings(prevRatings => ({ ...prevRatings, [id]: newValue })); // update state with new rating value

    const markBy = getUsername?.split(" ")[0] || 'system';
    // start loading for this proposal (use req_id as key)
    setRatingLoading((prev) => ({ ...prev, [req_id]: true }));
    
    updateRatingProposal(req_id, newValue, markBy)
      .then((res) => {
        // no toast: ลด side-effect ที่ทำให้ Drawer ปิดเอง
        // อัปเดตสถานะภายในให้ดาวสะท้อนค่าทันที
        setProposalDetail((prev) =>
          Array.isArray(prev)
            ? prev.map((p) => (p?.req_id === req_id ? { ...p, mark: newValue } : p))
            : prev
        );
        
        // รีเฟรชตารางหลังบันทึกสำเร็จเพื่ออัปเดตค่าในตาราง (ไม่ปิด Drawer)
        if (onRefreshData) {
          setTimeout(() => {
            onRefreshData();
          }, 500);
        }
      })
      .catch((err) => {
        // เงียบเพื่อไม่กระทบ Drawer; ถ้าต้องการค่อยเพิ่ม inline error เล็กๆ
      })
      .finally(() => {
        // stop loading for this proposal
        setRatingLoading((prev) => ({ ...prev, [req_id]: false }));
      });
  };



  const onEditClick = () => {
    setOnEdit(!onEdit);
  };



  const fetchInternStudent = (id) => {
    try {
      
     
      getInternshipRequestById(id)
        .then(async (res) => {
          const list = res.filter((el) => {
            return el.req_id == id;
          });
          const allStaff = await engApi.get("/all-staff/");
          const documentReqStudent = await getDocumentReqStudent();
          const totalScoreCompany = await getTotalScoreOnly(id);
          const supervisor = allStaff.data?.find(
            (el) => el?.id == list[0]?.supervisor
            
          );
          const documentReqStudent1 = documentReqStudent?.find(
            (el) => el.st_id == list[0].st_id  && el.cp_id == list[0].cp_id
          );  
          list[0].documentRequest = documentReqStudent1;
          list[0].supervisorName = supervisor?.name;
          list[0].totalScoreCompany = totalScoreCompany?.total_score;
          
          // Fetch company (supervisor) evaluation for Coop and attach as convenience fields
          try {
            const companyCoopAll = await getAssessment_companycoop();
            const companyCoop = (companyCoopAll || []).find((el) => el.req_id == id);
            if (companyCoop) {
              list[0].coopCompanyScore = companyCoop.total_score || companyCoop.totalScore || 0;
              list[0].coopCompanyMax = companyCoop.max_score || 200;
            }
          } catch (e) {
            console.log('getAssessment_companycoop failed', e);
          }
          
          // Fetch report evaluation for Coop
          try {
            const reportCoopAll = await getAssessment_reportcoop();
            const reportCoop = (reportCoopAll || []).find((el) => el.req_id == id);
            if (reportCoop) {
              list[0].coopReportScore = reportCoop.total_score || 0;
              list[0].coopReportMax = reportCoop.max_score || 100;
            }
          } catch (e) {
            console.log('getAssessment_reportcoop failed', e);
          }

          // Fetch visit evaluation for Coop
          try {
            const visitCoopAll = await getAssessmentCoop();
            const visitCoopRecords = (visitCoopAll || []).filter((el) => el.req_id == id);
            console.log('Visit evaluation data:', visitCoopRecords);
            
            if (visitCoopRecords.length > 0) {
              // Use only the latest record (not sum all records)
              const latestRecord = visitCoopRecords[visitCoopRecords.length - 1];
              let totalScore = 0;
              
              // Sum all list_X scores from the latest record only (list_1 to list_24)
              for (let i = 1; i <= 24; i++) {
                const listKey = `list_${i}`;
                if (latestRecord[listKey]) {
                  totalScore += parseInt(latestRecord[listKey]) || 0;
                }
              }
              
              list[0].coopVisitScore = totalScore;
              list[0].coopVisitMax = latestRecord.max_score || 120;
            }
          } catch (e) {
            console.log('getAssessmentCoop failed', e);
          }

          // Fetch present evaluation for Coop  
          try {
            const presentCoopAll = await getAssessment_presentcoop();
            const presentCoopRecords = (presentCoopAll || []).filter((el) => el.req_id == id);
            console.log('Present evaluation data:', presentCoopRecords);
            
            if (presentCoopRecords.length > 0) {
              // Use only the latest record (not sum all records)
              const latestRecord = presentCoopRecords[presentCoopRecords.length - 1];
              let totalScore = 0;
              
              // Sum all list_X scores from the latest record only
              for (let i = 1; i <= 10; i++) {
                const listKey = `list_${i}`;
                if (latestRecord[listKey]) {
                  totalScore += parseInt(latestRecord[listKey]) || 0;
                }
              }
              
              list[0].coopPresentScore = totalScore;
              list[0].coopPresentMax = latestRecord.max_score || 50;
            }
          } catch (e) {
            console.log('getAssessment_presentcoop failed', e);
          }
          
          // Fetch visit assessment for 2-month internship
          try {
            const visitInternAll = await getAssessment();
            const visitInternRecords = (visitInternAll || []).filter((el) => el.req_id == id);
            console.log('🔍 Intern visit evaluation ALL data:', visitInternAll);
            console.log('🔍 Intern visit evaluation filtered records:', visitInternRecords);
            
            if (visitInternRecords.length > 0) {
              console.log('🔍 First record structure:', visitInternRecords[0]);
              
              // Use only the latest record (not sum all records)
              const latestRecord = visitInternRecords[visitInternRecords.length - 1];
              let totalScore = 0;
              
              // Sum all list_X scores from the latest record only
              for (let i = 1; i <= 12; i++) {
                const listKey = `list_${i}`;
                if (latestRecord[listKey]) {
                  totalScore += parseInt(latestRecord[listKey]) || 0;
                }
              }
              
              console.log('🔍 Calculated total score:', totalScore);
              
              list[0].internVisitScore = totalScore;
              list[0].internVisitMax = latestRecord.max_score || 60;
            }
          } catch (e) {
            console.log('getAssessment failed', e);
          }

          // Fetch report/presentation assessment for 2-month internship
          try {
            const reportInternAll = await getAssessment_report();
            const reportInternRecords = (reportInternAll || []).filter((el) => el.req_id == id);
            console.log('🔍 Intern report evaluation ALL data:', reportInternAll);
            console.log('🔍 Intern report evaluation filtered records:', reportInternRecords);
            
            if (reportInternRecords.length > 0) {
              console.log('🔍 First record structure:', reportInternRecords[0]);
              
              // Use only the latest record (not sum all records)
              const latestRecord = reportInternRecords[reportInternRecords.length - 1];
              let totalScore = 0;
              
              // Sum all list_X scores from the latest record only
              for (let i = 1; i <= 8; i++) {
                const listKey = `list_${i}`;
                if (latestRecord[listKey]) {
                  totalScore += parseInt(latestRecord[listKey]) || 0;
                }
              }
              
              console.log('🔍 Calculated total score:', totalScore);
              
              list[0].internReportScore = totalScore;
              list[0].internReportMax = latestRecord.max_score || 40;
            }
          } catch (e) {
            console.log('getAssessment_report failed', e);
          }
          
          // Debug: Log all scores before setting
          console.log('Final profile data with scores:', {
            coopVisitScore: list[0].coopVisitScore,
            coopPresentScore: list[0].coopPresentScore,
            coopCompanyScore: list[0].coopCompanyScore,
            coopReportScore: list[0].coopReportScore,
            internVisitScore: list[0].internVisitScore,
            internReportScore: list[0].internReportScore
          });
          
          setProfileDetail(list[0]);


        })
        .catch((err) => {
          console.log(err);
        });





    } catch (err) {
      console.log(err);
    } 
  };




  const fetchLogbookbyReqID = (id) => {
    try {
  
      getLogbookById(id)
        .then((res) => {
          const list = res.filter((el) => {
            return el.req_id == id;
          });

          setLogbookDetail(list);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    } 
  };




  const fetchInternReportbyReqID = (id) => {
    try {
      
      getInternReportById(id)
        .then((res) => {
        //  console.log("res", res, id);
          const list = res.filter((el) => {
            return el.req_id == id;
          });
          console.log(list);
          setInternReportDetail(list);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const fetchCoopReportbyReqID = (id) => {
    try {
      
      getCoopReportById(id)
        .then((res) => {
          //console.log("res", res, id);
          const list = res.filter((el) => {
            return el.req_id == id;
          });
         // console.log(list);
          setCoopReportDetail(list);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  };






  const fetchProposalbyReqID = (id) => {
    try {
     
      getProposalById(id)
        .then((res) => {
        //  console.log("res", res, id);
          const list = res.filter((el) => {
            return el.req_id == id;
          });
         // console.log(list);
          setProposalDetail(list);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    } 
  };

  const fetchinternManualbyReqID = (id) => {
    try {
      
      getInternManualById(id)
        .then((res) => {
          const list = res.filter((el) => {
            return el?.intern_request_id == id;
          });
          const dataJson = JSON.parse(list[0].manual_data);
          const auditor = dataJson.auditor;
          setAuditor(auditor);

          //console.log("internManualDetail", list);
          setInternManualDetail(list);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    } 
  };

  useEffect(() => {
    if (internRequestId) {
      setIsLoading(true);
      Promise.all([
        fetchInternStudent(internRequestId),
        fetchLogbookbyReqID(internRequestId),
        fetchInternReportbyReqID(internRequestId),
        fetchCoopReportbyReqID(internRequestId),
        fetchProposalbyReqID(internRequestId),
        fetchinternManualbyReqID(internRequestId)
      ]).then(() => {
        setIsLoading(false);
      });
    }
  }, [internRequestId]);

  const bodymail = `เรียน ผู้ดูแล/พี่เลี้ยงนิสิตฝึกงาน \n 
ตามที่${profileDetail?.cp_name} ได้รับ ${profileDetail?.st_name} รหัสนิสิต ${profileDetail?.st_id} สาขาวิชา ${optionsBranch?.find((el) => el.value == profileDetail?.b_id)?.label}
จากคณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา เข้าฝึกงานและสหกิจศึกษาปี ${parseInt(currentYear)+1} ระหว่างวันที่ ${convertDateThai(profileDetail?.start_date,false)} - ${convertDateThai(profileDetail?.end_date,false)} นั้น

ทางคณะวิศวกรรมศาสตร์ขอความกรุณาท่านประเมินผลการฝึกงาน 2 เดือนของนิสิตดังกล่าว โดยกรอกแบบประเมินผ่านลิงค์ต่อไปนี้:
https://forms.gle/DLXTMLhqMqRKxQpe8
  
หากท่านมีข้อสงสัยหรือต้องการข้อมูลเพิ่มเติม กรุณาติดต่องานสหกิจศึกษา คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา 
ที่เบอร์โทรศัพท์ 038-102222 ต่อ 3315 หรืออีเมล co-op@eng.buu.ac.th
ขอขอบคุณในความร่วมมือของท่านมา ณ โอกาสนี้

ขอแสดงความนับถือ
งานสหกิจศึกษา ฝ่ายพัฒนานิสิต
คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา`;

const bodymailcoop = `เรียน ผู้ดูแล/พี่เลี้ยงนิสิตฝึกงาน \n 
ตามที่${profileDetail?.cp_name} ได้รับ ${profileDetail?.st_name} รหัสนิสิต ${profileDetail?.st_id} สาขาวิชา ${optionsBranch?.find((el) => el.value == profileDetail?.b_id)?.label}
จากคณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา เข้าฝึกงานและสหกิจศึกษาปี ${parseInt(currentYear)+1} ระหว่างวันที่ ${convertDateThai(profileDetail?.start_date,false)} - ${convertDateThai(profileDetail?.end_date,false)} นั้น

ทางคณะวิศวกรรมศาสตร์ขอความกรุณาท่านประเมินผลประเมินผลการปฏิบัติสหกิจศึกษาและรายงานโครงงานสหกิจศึกษาของนิสิตดังกล่าว 
โดยกรอกแบบประเมินผ่านลิงค์ต่อไปนี้:
1) ENG-Coop C003 แบบประเมินผลการปฏิบัติสหกิจศึกษา
https://forms.gle/NLHrMfzV2gxJ9TtA9

2) ENG-Coop C004 แบบประเมินผลรายงานสหกิจศึกษา
https://forms.gle/N6ERsj2NFBxrKVMa6

  
หากท่านมีข้อสงสัยหรือต้องการข้อมูลเพิ่มเติม กรุณาติดต่องานสหกิจศึกษา คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา 
ที่เบอร์โทรศัพท์ 038-102222 ต่อ 3315 หรืออีเมล co-op@eng.buu.ac.th
ขอขอบคุณในความร่วมมือของท่านมา ณ โอกาสนี้

ขอแสดงความนับถือ
งานสหกิจศึกษา ฝ่ายพัฒนานิสิต
คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา`;

  const displayContent = (
    <div className="card mb-3">
      <div className="card-header bg-light">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <AssignmentIcon sx={{ color: '#1976d2', fontSize: 24 }} />
            <h5 className="mb-0">
              <span className="text-muted" style={{ fontSize: '0.9rem', fontWeight: 400 }}>Request ID: </span>
              <span style={{ color: '#1976d2', fontWeight: 600, fontSize: '1.1rem' }}>
                {profileDetail?.req_id}
              </span>
            </h5>
          </div>
          <Link 
            to={`/student-evaluation?req_id=${profileDetail?.req_id}`}
            target="_blank"
            className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
          >
            <OpenInNew fontSize="small" />
            ดูหน้าประเมินผลเต็ม
          </Link>
        </div>
      </div>

      <div className="card-body text-center">
        {profileDetail && !isNaN(profileDetail.st_id) ? (
          
          <img
            src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${profileDetail?.st_id}`}
            width="120px"
          />
        ) : (
          <img src={`./assets/images/user.png`} width="120px" />
        )}


        <h5 className="card-title mb-0">{profileDetail?.st_name}</h5>
        <div className="text-muted mb-2">
          <span>{profileDetail?.st_id}</span>
        </div>
      </div>
      <hr className="my-0" />
      <div className="card-body">
        <form action="./update-student-internship-details.php" method="post">
          <table class="table table-sm my-2">
            <tbody>
              <tr>
                <th>สาขาวิชา</th>
                <td>
                  {
                    optionsBranch?.find((el) => el.value == profileDetail?.b_id)
                      ?.label
                  }
                </td>
              </tr>
              <tr>
                <th>เกรดเฉลี่ยสะสม</th>
                <td>{(+profileDetail?.GPA)?.toFixed(2)}</td>
              </tr>
              <tr>
                <th>Email</th>
                <td>
                  {/* {profileDetail?.st_mail} */}
                  <a href={`mailto:${profileDetail?.st_mail}`}>

                    {profileDetail?.st_mail} {"  "}
                  </a>
                  {profileDetail?.st_mail && (
                    <CopyToClipboard
                      text={profileDetail?.st_mail}
                      onCopy={() => setCopiedmail("true")}
                    >
                      <ContentCopyIcon sx={{ width: 15 }} />
                    </CopyToClipboard>
                  )}
                  {CopiedMail ? (
                    <span style={{ color: "red" }}>Copied.</span>
                  ) : null}
                  {/* <input
                    readOnly={!onEdit}
                    className={`form-control ps-0 ${
                      !onEdit && "field-editable"
                    }`}
                    name="email"
                    defaultValue={profileDetail?.st_mail}
                    style={{ color: "inherit" }}
                  /> */}
                </td>
              </tr>
              <tr>
                <th>เบอร์โทร</th>
                <td>
                  <a href={`tel:${profileDetail?.st_tel}`}>
                    {profileDetail?.st_tel} {"  "}
                  </a>
                  {profileDetail?.st_tel && (
                    <CopyToClipboard
                      text={profileDetail?.st_tel}
                      onCopy={() => setCopied("true")}
                    >
                      <ContentCopyIcon sx={{ width: 15 }} />
                    </CopyToClipboard>
                  )}
                  {Copied ? (
                    <span style={{ color: "red" }}>Copied.</span>
                  ) : null}
                </td>
              </tr>
              <tr>
                <th>สถานะ</th>
                <td>
                  <span>
                    {!!profileDetail &&
                      generateStatus(profileDetail?.status_id)}
                  </span>
                </td>
              </tr>

              <tr>
                <th>สถานประกอบการ</th>
                <td>
                  <span className="badge bg-info">
                    ID : {profileDetail?.cp_id}
                  </span>{" "}
                  {profileDetail?.cp_name}{" "}
                </td>
              </tr>

              <tr>
                <th>ประเภทการฝึกงาน</th>
                <td>
                  {matchOptions(internType, profileDetail?.type_internship)}
                </td>
              </tr>

              <tr>
                <th>ช่วงวันที่</th>
                <td>
                  <div className="d-flex align-items-center justify-content-between">
                    {!onEdit ? (
                      <div>
                        {convertDateToString(profileDetail?.start_date)} -{" "}
                        {convertDateToString(profileDetail?.end_date)}
                      </div>
                    ) : (
                      <div className="d-flex align-items-center">
                        <span>{profileDetail?.start_date}</span>
                        <div> - </div>
                        <input
                          readOnly={
                            !onEdit &&
                            (profileDetail.status !== "1" ||
                              profileDetail.status !== "2")
                          }
                          className={`form-control w-50 ps-0 ${
                            !onEdit &&
                            (profileDetail.status !== "1" ||
                              profileDetail.status !== "2") &&
                            "field-editable"
                          }`}
                          style={{ color: "inherit" }}
                          name="end_date"
                          defaultValue={profileDetail?.end_date}
                        />
                        <IconButton type="submit" size="small" sx={{ p: 0.5 }}>
                          <CheckCircle
                            sx={{ color: "green", fontSize: 16 }}
                          />
                        </IconButton>
                      </div>
                    )}
                    <IconButton onClick={onEditClick} size="small" sx={{ p: 0.5 }}>
                      <Edit sx={{ fontSize: 16 }} />
                    </IconButton>
                  </div>
                </td>
              </tr>

              <tr>
                <th>ปีการศึกษาฝึกงาน</th>
                <td>
                  <div className="d-flex align-items-center justify-content-between">
                    {!onEdit ? (
                      <div>
                        {profileDetail?.school_yrs || currentYear}
                      </div>
                    ) : (
                      <div className="d-flex align-items-center">
                        <input
                          readOnly={
                            !onEdit &&
                            (profileDetail.status !== "1" ||
                              profileDetail.status !== "2")
                          }
                          className={`form-control w-50 ps-0 ${
                            !onEdit &&
                            (profileDetail.status !== "1" ||
                              profileDetail.status !== "2") &&
                            "field-editable"
                          }`}
                          style={{ color: "inherit" }}
                          name="school_yrs"
                          defaultValue={profileDetail?.school_yrs || currentYear}
                          placeholder="เช่น 2567"
                        />
                        <IconButton type="submit" size="small" sx={{ p: 0.5 }}>
                          <CheckCircle
                            sx={{ color: "green", fontSize: 16 }}
                          />
                        </IconButton>
                      </div>
                    )}
                    <IconButton onClick={onEditClick} size="small" sx={{ p: 0.5 }}>
                      <Edit sx={{ fontSize: 16 }} />
                    </IconButton>
                  </div>
                </td>
              </tr>

              {/* {profileDetail?.status == 2 && (
                <tr>
                  <th></th>
                  <td>
                    <div
                      className="ms-2 text-secondary"
                      onClick={() => setIsOpenModalForm(true)}
                      type="button"
                    >
                      <GrDocumentVerified /> คำร้องขอฝึกงานที่อนุมัติ
                    </div>
                  </td>
                </tr>
              )} */}
               <tr>
                <th>อาจารย์นิเทศ</th>
                <td>
                {profileDetail?.supervisorName}
                
                </td>
              </tr>

              <tr>
                <th></th>
                <td>
                  <Link to={`/activity-log?st_id=${profileDetail?.st_id}`}>
                    <AssignmentIcon fontSize="small" /> บันทึกการฝึกอบรม
                  </Link>
                </td>
              </tr>

              {(profileDetail?.status_id == "31" ||
                profileDetail?.status_id == "3") && (
                //profileDetail?.documentRequest?.idm_status == "3"
                //
                
                <tr>
                  <th></th>
                  
                  <td>
                    <div
                      onClick={() => setIsOpenDrawerFormReview(true)}
                      type="button"
                    >
                      <MailIcon fontSize="small" /> หนังสือส่งตัวนิสิต 
                      <a href={profileDetail?.documentRequest.doc_sending_url} target="_blank" rel="noopener noreferrer">
                      (เลขที่{" "}{profileDetail?.documentRequest.idm_doc_id}) </a>
                    </div>
                  </td>
                </tr>
              )}
             

              <tr>
                <th></th>
                <td>
                  <Stack
                    direction="row"
                    alignItems="center"
                    divider={
                      <Divider
                        orientation="vertical"
                        flexItem
                      />
                    }
                    spacing={2}
                  >
                    <Link
                      to={`/intern-manual?req_id=${profileDetail?.req_id}`}
                      target="_blank"
                    >
                      <LocationOnIcon fontSize="small" />{" "}
                      { !isMobile ? "แบบฟอร์มแจ้งที่ตั้งสถานประกอบการ" :

                     "แบบฟอร์มแจ้งที่ตั้ง" 
                      
                    }
                    </Link>


                    {internManualDetail && (
                    <Rating
                      size="small"
                      name={`rating-${internManualDetail[0]?.intern_request_id}`}
                      value={ratings[internManualDetail[0]?.intern_request_id] || internManualDetail[0]?.mark}
                      //precision={0.5}
                      getLabelText={getLabelText}
                      
                      onChange={(event, newValue) => handleRatingChange2(internManualDetail[0]?.intern_request_id, newValue)}
                      
                    />
                    )}
                   
                  </Stack>
                </td>
              </tr>

            

              {logbookDetail?.map((el) => {
              //  console.log("logbookDetail", el);
                return (
                  <tr key={el.id}>
                  
                  {el?.no == 1 ? <th>บันทึกการฝึกงาน</th>:<th></th>}
                  
                  
                  <td>
                    <Stack
                    direction="row"
                    alignItems="center"
                    divider={
                      <Divider
                      orientation="vertical"
                      flexItem
                      />
                    }
                    spacing={2}
                    >
                    <Tooltip title={`updated-${el?.date_updated}`} placement="top" arrow>
                    <a href={el?.link} target="_blank" rel="noopener noreferrer">
                      <PictureAsPdfIcon fontSize="small" 
                      /> Logbook#{el?.no}{" "}
                    </a>
                    </Tooltip>

                    <Rating
                      size="small"
                      name={`rating-${el.id}`}
                      value={ratings[el.id] || el.mark}
                      getLabelText={getLabelText}
                      allowEmpty={true}
                      onChange={(event, newValue) => handleRatingChange(el.id, newValue)}
                      onChangeActive={(event, newHover) => { setHover(newHover === -1 ? -1 : el.id); }}
                    />
                    {hover === el.id && (
                      <Box sx={{ ml: 2 }}>{labels[ratings[el.id]|| el.mark]}</Box>
                    
                      
                    )}
                    </Stack>
                  </td>
                  </tr>
                );
              })}

              {InternReportDetail?.map((el) => {
                if (profileDetail?.type_internship != 2) {
                  return (
                    <tr key={el.id}>
                      <th>ฝึกงาน 2 เดือน</th>
                      <td>
                        <Stack
                          direction="row"
                          alignItems="center"
                          divider={<Divider orientation="vertical" flexItem />}
                          spacing={2}
                        >
                          <div>
                            <a href={el?.link} target="_blank" rel="noopener noreferrer">
                              <AssignmentIcon fontSize="small" /> รายงานฝึกงาน 2 เดือน
                            </a>
                          </div>
                        </Stack>
                      </td>
                    </tr>
                  );
                }
                return null;
              })}
            

               {/* <tr>
              <th></th>
                <td>
                  <div>
                    <a href="https://forms.gle/jbSH38PVC5F3HPMaA" target="_blank">
                      <FactCheckIcon fontSize="small" color="secondary" /> ส่งฟอร์มประเมินการนิเทศงานสหกิจศึกษา
                    </a>
                  </div>
                </td>
              </tr> */}


              {profileDetail?.type_internship != 2 && (

                <tr>
                  <th></th>
                  <td>
                    {profileDetail?.internVisitScore > 0 ? (
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-2">
                          <CheckCircleIcon sx={{ color: 'green' }} fontSize="small" />
                          <span>ผลประเมินการนิเทศนิสิตฝึกงาน 2 เดือน</span>
                          <span className="badge bg-primary">
                            {parseFloat(profileDetail.internVisitScore) % 1 === 0 
                              ? parseInt(profileDetail.internVisitScore) 
                              : profileDetail.internVisitScore} / {parseFloat(profileDetail.internVisitMax) % 1 === 0 
                              ? parseInt(profileDetail.internVisitMax) 
                              : profileDetail.internVisitMax}
                          </span>
                        </div>
                        <Link
                          to={`/assessment-visit?req_id=${profileDetail?.req_id}`}
                          target="_blank"
                        >
                          <OpenInNew sx={{ fontSize: 16 }} />
                        </Link>
                      </div>
                    ) : (
                      <div>
                        <Link
                          to={`/assessment-visit?req_id=${profileDetail?.req_id}`}
                          target="_blank"
                        >
                          <FactCheckIcon fontSize="small" color="secondary" /> {" "}
                          ส่งผลประเมินการนิเทศนิสิตฝึกงาน 2 เดือน 
                        </Link>
                      </div>
                    )}
                  </td>
                </tr>
                )}
            


            {profileDetail?.type_internship != 2 && (
              <tr>
                <th></th>
                <td>
                  {profileDetail?.internReportScore > 0 ? (
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center gap-2">
                        <CheckCircleIcon sx={{ color: 'green' }} fontSize="small" />
                        <span>ผลประเมินรายงานและการนำเสนอฝึกงาน 2 เดือน</span>
                        <span className="badge bg-secondary">
                          {parseFloat(profileDetail.internReportScore) % 1 === 0 
                            ? parseInt(profileDetail.internReportScore) 
                            : profileDetail.internReportScore} / {parseFloat(profileDetail.internReportMax) % 1 === 0 
                            ? parseInt(profileDetail.internReportMax) 
                            : profileDetail.internReportMax}
                        </span>
                      </div>
                      <Link
                        to={`/assessment-report?req_id=${profileDetail?.req_id}`}
                        target="_blank"
                      >
                        <OpenInNew sx={{ fontSize: 16 }} />
                      </Link>
                    </div>
                  ) : (
                    <div>
                      <Link
                        to={`/assessment-report?req_id=${profileDetail?.req_id}`}
                        target="_blank"
                      >
                        <FactCheckIcon fontSize="small" color="success" /> {" "}
                        ส่งผลประเมินรายงานและการนำเสนอฝึกงาน 2 เดือน
                      </Link>
                    </div>
                  )}
                </td>
              </tr> 
            )}

              {profileDetail?.type_internship != 2 && (
                <tr>
                  <th></th>
                  <td>
                    <div>
                      {profileDetail?.totalScoreCompany ? (
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                          <div className="d-flex align-items-center gap-2">
                            <CheckCircleIcon fontSize="small" color="success" />
                            <span>ผลประเมินจากสถานประกอบการ</span>
                            <span className="badge bg-success">
                              {parseFloat(profileDetail?.totalScoreCompany) % 1 === 0 ? parseInt(profileDetail?.totalScoreCompany) : profileDetail?.totalScoreCompany} / 85
                            </span>
                            
                            <Tooltip title="ส่งอีเมลอีกครั้ง" placement="top" arrow>
                              <a href={`https://mail.google.com/mail/?view=cm&fs=1&to=${auditor?.fax}
          &su=${encodeURIComponent('ขอความอนุเคราะห์ประเมินผลการฝึกงาน 2 เดือน - นิสิตฝึกงาน ' + profileDetail?.st_name)}
          &body=${encodeURIComponent(bodymail)}`}
                                target="_blank"
                                style={{ textDecoration: 'none', color: 'inherit' }}
                              >
                                <Email fontSize="small" />
                              </a>
                            </Tooltip>
                          </div>
                          
                          <Tooltip title="ดูรายละเอียดการประเมิน" placement="top" arrow>
                            <Link
                              to={`/internship-evaluation?req_id=${profileDetail?.req_id}`}
                              target="_blank"
                              className="d-inline-flex align-items-center"
                              style={{ textDecoration: 'none', color: '#1976d2' }}
                            >
                              <OpenInNew sx={{ fontSize: 16 }} />
                            </Link>
                          </Tooltip>
                        </div>
                      ) : (
                        <a href={`https://mail.google.com/mail/?view=cm&fs=1&to=${auditor?.fax}
              &su=${encodeURIComponent('ขอความอนุเคราะห์ประเมินผลการฝึกงาน 2 เดือน - นิสิตฝึกงาน ' + profileDetail?.st_name)}
              &body=${encodeURIComponent(bodymail)}`}
                          target="_blank">
                          <Email fontSize="small" color="primary" />
                          {" "}ส่ง e-mail ให้พี่เลี้ยงเพื่อประเมินผลฝึกงาน 2 เดือน
                        </a>
                      )}
                    </div>
                  </td>
                </tr>
              )}


             
              {profileDetail?.type_internship != 1 &&
                proposalDetail?.map((el) => {
                   
                  return (

                    <tr>
                    <th>สหกิจศึกษา</th>
                    <td>
                      <Stack
                        direction="row"
                        alignItems="center"
                        divider={<Divider orientation="vertical" flexItem />}
                        spacing={2}
                      >
                        <div>
                        <Tooltip title={`updated-${el?.date_updated}`} placement="top" arrow>
                          <a href={el?.link} target="_blank" rel="noopener noreferrer">
                            <AssignmentIcon fontSize="small" /> รายละเอียดโครงงานสหกิจศึกษาฯ
                         
                          </a>
                          </Tooltip>
                        </div>

                          <Rating
                            size="small"
                            name={`rating-proposal-${el?.req_id}`}
                            value={ratings[el?.id] || el?.mark}
                            //precision={0.5}
                            getLabelText={getLabelText}
                            onChange={(event, newValue) => handleRatingChange3(el?.id, el?.req_id, newValue)}
                            disabled={!!ratingLoading[el?.req_id]}
                          />
                          {ratingLoading[el?.req_id] && (
                            <CircularProgress size={16} thickness={5} sx={{ ml: 1 }} />
                          )}

                      </Stack>
                    </td>
                   

                  </tr>
                );
              })}


              {CoopReportDetail?.map((el) => {
                return (
                  <tr>
                    <th>
                      {proposalDetail?.length === 0 && "สหกิจศึกษา"}
                    </th>
                    <td>
                      <Stack
                        direction="row"
                        alignItems="center"
                        divider={<Divider orientation="vertical" flexItem />}
                        spacing={2}
                      >
                        <div>
                          <a href={el?.link} target="_blank" rel="noopener noreferrer">
                            <TaskIcon fontSize="small" /> รายงานสหกิจศึกษา
                          </a>
                        </div>
                      </Stack>
                    </td>
                  </tr>
                );
              })}

              {profileDetail?.type_internship != 1 &&
                <tr>
                  <th>{(profileDetail?.type_internship != 1 && CoopReportDetail?.length === 0 && proposalDetail?.length === 0) && "สหกิจศึกษา"}
                  </th>
                  <td>
                    {profileDetail?.coopVisitScore > 0 ? (
                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <div className="d-flex align-items-center gap-2">
                          <CheckCircleIcon fontSize="small" color="primary" />
                          <span>ผลประเมินการนิเทศ</span>
                          <span className="badge bg-primary">
                            {parseFloat(profileDetail?.coopVisitScore) % 1 === 0 ? parseInt(profileDetail?.coopVisitScore) : profileDetail?.coopVisitScore} / {parseFloat(profileDetail?.coopVisitMax) % 1 === 0 ? parseInt(profileDetail?.coopVisitMax) : profileDetail?.coopVisitMax}
                          </span>
                        </div>
                        <Tooltip title="ดูรายละเอียดการประเมิน" placement="top" arrow>
                          <Link
                            to={`/assessment-visitcoop?req_id=${profileDetail?.req_id}`}
                            target="_blank"
                            className="d-inline-flex align-items-center"
                            style={{ textDecoration: 'none', color: '#1976d2' }}
                          >
                            <OpenInNew sx={{ fontSize: 16 }} />
                          </Link>
                        </Tooltip>
                      </div>
                    ) : (
                      <Link
                        to={`/assessment-visitcoop?req_id=${profileDetail?.req_id}`}
                        target="_blank"
                      >
                        <FactCheckIcon fontSize="small" color="secondary" /> {" "}
                        ส่งผลประเมินการนิเทศนิสิตสหกิจศึกษา
                      </Link>
                    )}
                  </td>
                </tr>
              }

              {profileDetail?.type_internship != 1 &&
                <tr>
                  <th></th>
                  <td>
                    {profileDetail?.coopPresentScore > 0 ? (
                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <div className="d-flex align-items-center gap-2">
                          <CheckCircleIcon fontSize="small" color="secondary" />
                          <span>ผลประเมินการนำเสนอ</span>
                          <span className="badge bg-secondary">
                            {parseFloat(profileDetail?.coopPresentScore) % 1 === 0 ? parseInt(profileDetail?.coopPresentScore) : profileDetail?.coopPresentScore} / {parseFloat(profileDetail?.coopPresentMax || 50) % 1 === 0 ? parseInt(profileDetail?.coopPresentMax || 50) : (profileDetail?.coopPresentMax || 50)}
                          </span>
                        </div>
                        <Tooltip title="ดูรายละเอียดการประเมิน" placement="top" arrow>
                          <Link
                            to={`/assessment-presentcoop?req_id=${profileDetail?.req_id}`}
                            target="_blank"
                            className="d-inline-flex align-items-center"
                            style={{ textDecoration: 'none', color: '#1976d2' }}
                          >
                            <OpenInNew sx={{ fontSize: 16 }} />
                          </Link>
                        </Tooltip>
                      </div>
                    ) : (
                      <Link
                        to={`/assessment-presentcoop?req_id=${profileDetail?.req_id}`}
                        target="_blank"
                      >
                        <FactCheckIcon fontSize="small" color="success" /> {" "}
                        ส่งผลประเมินการนำเสนอสหกิจศึกษา
                      </Link>
                    )}
                  </td>
                </tr>
              }

              {profileDetail?.type_internship != 1 && profileDetail?.coopCompanyScore > 0 && (
                <tr>
                  <th></th>
                  <td>
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                      <div className="d-flex align-items-center gap-2">
                        <CheckCircleIcon fontSize="small" color="success" />
                        <span>ผลประเมินการปฏิบัติงาน</span>
                        <span className="badge bg-success">
                          {parseFloat(profileDetail?.coopCompanyScore) % 1 === 0 ? parseInt(profileDetail?.coopCompanyScore) : profileDetail?.coopCompanyScore} / {parseFloat(profileDetail?.coopCompanyMax || 200) % 1 === 0 ? parseInt(profileDetail?.coopCompanyMax || 200) : (profileDetail?.coopCompanyMax || 200)}
                        </span>
                        <Tooltip title="ส่งอีเมลอีกครั้ง" placement="top" arrow>
                          <a href={`https://mail.google.com/mail/?view=cm&fs=1&to=${auditor?.fax}
          &su=${encodeURIComponent('ขอความอนุเคราะห์ประเมินผลการปฏิบัติงานนิสิตสหกิจศึกษา - นิสิตฝึกงาน ' + profileDetail?.st_name)}
          &body=${encodeURIComponent(bodymailcoop)}`}
                            target="_blank"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                          >
                            <Email fontSize="small" />
                          </a>
                        </Tooltip>
                      </div>
                      <Tooltip title="ดูรายละเอียดการประเมิน" placement="top" arrow>
                        <Link
                          to={`/supervisor-evaluation?req_id=${profileDetail?.req_id}`}
                          target="_blank"
                          className="d-inline-flex align-items-center"
                          style={{ textDecoration: 'none', color: '#1976d2' }}
                        >
                          <OpenInNew sx={{ fontSize: 16 }} />
                        </Link>
                      </Tooltip>
                    </div>
                  </td>
                </tr>
              )}

              {profileDetail?.type_internship != 1 && profileDetail?.coopReportScore > 0 && (
                <tr>
                  <th></th>
                  <td>
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                      <div className="d-flex align-items-center gap-2">
                        <CheckCircleIcon fontSize="small" style={{ color: '#212529' }} />
                        <span>ผลประเมินเล่มรายงาน</span>
                        <span className="badge bg-dark">
                          {parseFloat(profileDetail?.coopReportScore) % 1 === 0 ? parseInt(profileDetail?.coopReportScore) : profileDetail?.coopReportScore} / {parseFloat(profileDetail?.coopReportMax || 100) % 1 === 0 ? parseInt(profileDetail?.coopReportMax || 100) : (profileDetail?.coopReportMax || 100)}
                        </span>
                      </div>
                      <Tooltip title="ดูรายละเอียดการประเมิน" placement="top" arrow>
                        <Link
                          to={`/coop-report-evaluation?req_id=${profileDetail?.req_id}`}
                          target="_blank"
                          className="d-inline-flex align-items-center"
                          style={{ textDecoration: 'none', color: '#1976d2' }}
                        >
                          <OpenInNew sx={{ fontSize: 16 }} />
                        </Link>
                      </Tooltip>
                    </div>
                  </td>
                </tr>
              )}



              { profileDetail?.type_internship != 1 && !profileDetail?.coopCompanyScore &&
              <tr>
              <th></th>
                <td>
                  <div>
                    <a href={`https://mail.google.com/mail/?view=cm&fs=1&to=${auditor?.fax}
                        &su=${encodeURIComponent('ขอความอนุเคราะห์ประเมินผลการปฏิบัติงานนิสิตสหกิจศึกษา - นิสิตฝึกงาน ' + profileDetail?.st_name)}
                        &body=${encodeURIComponent(bodymailcoop)}`}
                      target="_blank">
                      <Email fontSize="small" color="success" /> {" "}
                      ส่ง e-mail ให้พี่เลี้ยงเพื่อประเมินผลการปฏิบัติงานนิสิตสหกิจศึกษา
                    </a>
                  </div>
                </td>
              </tr>}

            </tbody>
          </table>

          <input className="d-none" value={profileDetail?.st_id} name="st_id" />
          <input className="d-none" value={profileDetail?.req_id} name="req_id" />
          <input className="d-none" value={getUsername} name="user" />
        </form>
      </div>
    </div>
  );



  return (
    <>
      {profileDetail === null 
       ? (
        
        <Container>
        <Box 
          flexDirection={"column"} 
          display={"flex"} 
          justifyContent={"center"}
          alignItems={"center"}
          padding={4}
          sx={{ width: "100%" }}
        >
          <CircularProgress />
          Loading...

          
        
     
        </Box>
      </Container>
    

      ) : (
        displayContent 
        
      )}

      <ModalView
        isModaOpen={isOpenModalForm}
        setIsModalOpen={setIsOpenModalForm}
      >
        <InternPageReview data={profileDetail} readOnly />
      </ModalView>

      <DrawerView
        isOpen={isOpenDrawerFormReview}
        setIsOpen={setIsOpenDrawerFormReview}
        content=""
      >
        <FormReviewCompleted data={profileDetail?.documentRequest} />
      </DrawerView>
       
    </>
  );
};

export default InternStdDetail;
